<template>
<div class="back-office">
	<MainNav />
	<div class="bg-light py-2 mb-4">
		<div class="container">
			<h1>Back Office</h1>
			<ul class="nav">
				<li class="nav-item">
					<a class="nav-link" v-bind:class="{ active: chosenTab === '#users'}" href="#users">Users</a>
				</li>
				<li class="nav-item">
					<a class="nav-link" v-bind:class="{ active: chosenTab === '#reports'}" href="#reports">Reports</a>
				</li>
			</ul>
		</div>
	</div>
	<div class="container" v-if="chosenTab === '#users'">
		<div v-if="loading" class="py-4 d-flex justify-content-center">
			<div class="spinner-border text-primary" role="status">
				<span class="sr-only">Loading...</span>
			</div>
		</div>
		<div v-else>
			<div class="row align-items-center">
				<div class="col-md-10">
					<form novalidate>
						<div class="form-row">
							<div class="form-group col-md-3">
								<label for="searchFilter">Search</label>
								<input type="text" class="form-control" id="searchFilter" v-model="searchFilter" style="height: auto;" />
							</div>
							<div class="form-group col-md-3">
								<label for="AccountType">Filter users</label>
								<select class="form-control" id="AccountType" v-model="accountFilter" style="height: auto;" >
									<option value="all">All</option>
									<option v-for="type in accountTypes" :key="type.Id" :value="type.Id">
										{{type.Name}}
									</option>
								</select>
							</div>
						</div>
					</form>
				</div>
				<div class="col-md-2 text-center">
					<router-link class="btn btn-lg btn-primary" :to="{ name: 'add-user'}" exact>Add User</router-link>
				</div>
			</div>
			<div class="row" v-if="userDeleteSuccess === false && userDeleteErrors.length > 0">
				<div class="col-12">
					<div class="alert alert-danger" v-for="(error, index) in userDelteErrors" :key="'user-delete-error-'+index">
						<p class="m-0">{{ error }}</p>
					</div>
				</div>
			</div>
			<div class="row" v-if="userDeleteSuccess === true && userDeleteErrors.length === 0">
				<div class="col-12">
					<div class="alert alert-success">
						<p class="m-0">User deleted successfully</p>
					</div>
				</div>
			</div>
			<div class="table-responsive">
				<table class="table">
					<thead>
						<tr>
							<th scope="col">First</th>
							<th scope="col">Last</th>
							<th scope="col">Company</th>
							<th scope="col">Type</th>
							<th scope="col">&nbsp;</th>
						</tr>
					</thead>
					<tbody>
						<tr v-for="user in paginatedData" v-bind:key="user.Id">
							<td>{{user.FirstName || "n/a"}} </td>
							<td>{{user.LastName || "n/a"}}</td>
							<td>{{user.Organisation || "n/a"}}</td>
							<td v-html="accountType(user.AccountType)"></td>
							<td>
								<router-link class="btn btn-sm btn-primary" :to="{ name: 'edit-user', params: { id: user.Id } }">Edit</router-link>
								<button class="btn btn-sm btn-danger ml-0 ml-md-2" @click="showDeleteConfirm(user)">Delete</button>
							</td>
						</tr>
					</tbody>
				</table>
				<nav aria-label="Page navigation example">
					<ul class="pagination justify-content-center">
						<li class="page-item">
							<button class="page-link" @click="goToPage(1)" aria-label="Previous">
								<span aria-hidden="true">&laquo;</span>
							</button>
						</li>
						<li class="page-item">
							<button class="page-link" v-bind:class="{ disabled: pageNumber == 1 }" @click="prevPage" :disabled="pageNumber == 1" aria-label="First">
								<span aria-hidden="true">&lsaquo;</span>
							</button>
						</li>
						<li class="page-item" v-bind:class="{ active: page.name == pageNumber }" v-for="page in pages" :key="page.name">
							<button class="page-link" @click="goToPage(page.name)">{{page.name}}</button>
						</li>
						<li class="page-item">
							<button class="page-link" v-bind:class="{ disabled: pageNumber >= pageCount }" @click="nextPage" :disabled="pageNumber >= pageCount" aria-label="Next">
								<span aria-hidden="true">&rsaquo;</span>
							</button>
						</li>
						<li class="page-item">
							<button class="page-link" @click="goToPage(pageCount)" aria-label="Last">
								<span aria-hidden="true">&raquo;</span>
							</button>
						</li>
					</ul>
				</nav>
			</div>
		</div>
	</div>
	<div class="container" v-if="chosenTab === '#reports'">
		<div class="row">
			<div class="col-12">
				<h2>Reports</h2>
				<div v-if="loading" class="alert alert-warning fade show" role="alert">
					Loading...
				</div>
			</div>
		</div>
		<div class="row mt-4">
			<div class="col-12">
					<form>
						<div class="form-row align-items-end">
							<div class="form-group col-md-4">
								<label for="start">Start</label>
								<input type="date" class="form-control h-auto" id="start" v-model="csvStartDate">
							</div>
							<div class="form-group col-md-4">
								<label for="end">End</label>
								<input type="date" class="form-control h-auto" id="end" v-model="csvEndDate">
							</div>
							<div class="form-group col-md-4">
								<button class="btn btn-primary btn-lg mb-3" @click="getReportsCSV">Download Reports CSV</button>
							</div>
							<small class="form-text text-muted">Leave both inputs blank for all data</small>
						</div>
					</form>
			</div>
		</div>
		<div v-if="csvDownloadSuccess" class="alert alert-success alert-dismissible fade show my-4" role="alert">
			CSV downloaded successfully!
			<button type="button" class="close" data-dismiss="alert" aria-label="Close">
				<span aria-hidden="true">&times;</span>
			</button>
		</div>
	</div>
	<Footer />
</div>
</template>
<script>
import MainNav from "@/components/MainNav.vue";
import Footer from "@/components/Footer.vue";

export default {
  name: 'BackOffice',
  components: {
    MainNav,
    Footer
	},
	mounted() {
		this.$store.dispatch('getAllUsers');
	},
	watch: {
    '$route.hash': function (hash) {
      this.chosenTab = hash;
    }
	},
	data () {
		return {
			chosenTab: this.$route.hash || "#users",
			pageNumber: 1,
			size: 10,
			maxVisibleButtons: 5, //not including current page
			accountFilter: "all",
			accountTypes: [
				{
					Id: 0,
					Name: "Needs Validation"
				},
				{
					Id: 1,
					Name: "Non Trusted"
				},
				{
					Id: 2,
					Name: "Trusted"
				},
				{
					Id: 3,
					Name: "SLA"
				}
			],
			csvDownloadSuccess: false,
			searchFilter: "",
			csvStartDate: null,
			csvEndDate: null
		}
	},
	computed: {
    loading() {
      return this.$store.state.loading;
    },
    users() {
			return this.$store.getters.users;
		},
		userDeleteSuccess() {
			return this.$store.getters.userDeleteSuccess;
		},
		userDeleteErrors() {
			return this.$store.getters.userDeleteErrors;
		},
		pageCount(){
      let l = this.users.length,
          s = this.size;
      return Math.ceil(l/s);
		},
		paginatedData(){
    	const start = (this.pageNumber - 1) * this.size,
				end = start + this.size;

			if(this.accountFilter === "all"){
				return this.users.filter((user) => {

					if(user.Organisation !== null && user.Organisation.toLowerCase().includes(this.searchFilter.toLowerCase())){
						return user;
					}

					if(user.FirstName !== null && user.FirstName.toLowerCase().includes(this.searchFilter.toLowerCase())){
						return user;
					}

					if(user.LastName !== null && user.LastName.toLowerCase().includes(this.searchFilter.toLowerCase())){
						return user;
					}
				}).slice(start, end);
			} else {
				return this.users.filter(user => user.AccountType === this.accountFilter)
				.filter((user) => {

					if(user.Organisation !== null && user.Organisation.toLowerCase().includes(this.searchFilter.toLowerCase())){
						return user;
					}

					if(user.FirstName !== null && user.FirstName.toLowerCase().includes(this.searchFilter.toLowerCase())){
						return user;
					}

					if(user.LastName !== null && user.LastName.toLowerCase().includes(this.searchFilter.toLowerCase())){
						return user;
					}
				}).slice(start, end);
			}
		},
		startPage() {
      // When on the first page
      if (this.pageNumber === 1) {
        return 1;
      }
      // When on the last page
      if (this.pageNumber === this.pageCount) {
				if(this.pageCount <= this.maxVisibleButtons){
					this.pageNumber - 1;
				} else {
					return this.pageCount - this.maxVisibleButtons;
				}
      }
      // When in between
      return this.pageNumber - 1;
    },
    pages() {
      const range = [];

      for (let i = this.startPage; i <= Math.min(this.startPage + this.maxVisibleButtons, this.pageCount); i+= 1 ) {
        range.push({
          name: i,
          isDisabled: i === this.pageNumber
        });
      }

      return range;
    },
	},
	methods: {
		accountType (type) {
			switch (type) {
				case 0:
					return "Needs Validation";
				case 1:
					return "Non Trusted";
				case 2:
					return "Trusted";
				case 3:
					return "SLA";
				default:
					return "Borked";
					break;
			}
		},
		nextPage(){
			this.pageNumber++;
		},
		prevPage(){
			this.pageNumber--;
		},
		goToPage(pageNumber){
			this.pageNumber = pageNumber;
		},
		async getReportsCSV(){
      this.$store.commit("SET_LOADING", true);

      let reportCSV = await this.$reports.getReportsCSV(this.csvStartDate, this.csvEndDate);

      //All good
      if(reportCSV.status === 200){
				this.csvDownloadSuccess = true;
				const url = window.URL.createObjectURL(new Blob([reportCSV.data], {type: "text/csv"}));
				const link = document.createElement('a');
				link.href = url;
				link.setAttribute('download', 'ERCCIS_Data_Search_Reports.csv');
				document.body.appendChild(link);
				link.click();
      }

      //Server generated errors
      if(reportCSV.status === 400) {
        this.$store.commit("SET_LOADING", false);
        if(reportCSV.data) {
          if(reportCSV.data.ModelState) {
            let serverModelErrors = Object.values(reportCSV.data.ModelState).flat();
            this.signUpErrors = this.signUpErrors.concat(serverModelErrors);
          } else if(reportCSV.data.Message){
            this.signUpErrors.push(reportCSV.data.Message);
          }
        }
      }

      this.$store.commit("SET_LOADING", false);
		},
		showDeleteConfirm(user) {
			if(confirm(`Are you sure you want to delete user: ${user.FirstName} ${user.LastName}?`)){
				this.$store.dispatch("deleteUser", user.Id);
			}
		}
	}
};
</script>